import { isRebuildHost } from './environment';
export var SolutionViewerUrl;
(function (SolutionViewerUrl) {
    SolutionViewerUrl["PROD"] = "https://solution-viewer.ai4eng.aecom.services";
    SolutionViewerUrl["DEV"] = "https://solution-viewer.dev.ai4eng.aecom.team";
    SolutionViewerUrl["TEST_ENV"] = "https://solution-viewer.test.ai4eng.aecom.team";
    SolutionViewerUrl["SANDBOX"] = "https://solution-viewer-sandbox-b4dkhdb7bvcne3ek.z03.azurefd.net";
})(SolutionViewerUrl || (SolutionViewerUrl = {}));
export const getSolutionViewerUrl = () => {
    try {
        // A PDE's viewer cannot be derived from the host this app is served on.
        // Sign-in happens on the Static Web App default hostname
        // (`<random-words>.azurestaticapps.net`, see docs/PDE_AUTH_FLOW.md), which
        // carries no PDE identifier, and the viewer is that PDE's Container App
        // ingress — only monoweb gets per-PDE custom domains. So the deploy passes
        // the viewer in at build time; when it is set, it wins.
        const configured = import.meta.env.VITE_SOLUTION_VIEWER_URL?.trim();
        if (configured) {
            return configured.replace(/\/+$/, '');
        }
        const hostname = window.location.hostname;
        // On the rebuild domains, solution-viewer is the sibling host with the
        // service label (app/backoffice) swapped for `solution-viewer`.
        if (isRebuildHost(hostname)) {
            return `https://${hostname.replace(/^(pde-[^.]+\.)?(app|backoffice)\./, '$1solution-viewer.')}`;
        }
        switch (true) {
            // A build served on a Static Web App default hostname is a PDE: every
            // stable environment serves on a custom domain (the same rule as
            // isPdeEnvironment in libs/oauth). With no viewer configured there is no
            // way to reach that PDE's own, so shared dev is the closest answer —
            // production is the one that must never be guessed from a PDE. Checked
            // ahead of the substring cases below because the hostname is three random
            // words and may happen to contain any of them.
            case hostname.endsWith('.azurestaticapps.net'):
                return SolutionViewerUrl.DEV;
            // The old UAT environment now redirects to the new test environment.
            case hostname.includes('uat'):
                return SolutionViewerUrl.TEST_ENV;
            case hostname.includes('sandbox'):
                return SolutionViewerUrl.SANDBOX;
            case hostname.includes('dev'):
            case hostname.includes('local'):
                return SolutionViewerUrl.DEV;
            default:
                return SolutionViewerUrl.PROD;
        }
    }
    catch (error) {
        console.error('Error determining solution viewer URL:', error);
        // Fallback to PROD if something unexpected happens
        return SolutionViewerUrl.PROD;
    }
};
